module.exports = __webpack_public_path__ + "img/loop.9ee45eaf.webp";